/*------------------------------------*\
    MODULES
\*------------------------------------*/
// import $ from "jquery";

/*------------------------------------*\
    Flow Diagram
\*------------------------------------*/
class FlowDiagram {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.flowDiagram();
    }

    flowDiagram() {
        let self = this;

        var scroll = document.getElementById('flowDiagramRange');

        scroll.oninput = function () {
            var container = document.getElementById('flow-diagram');
            var total = container.scrollWidth - container.offsetWidth - 100;

            container.scrollLeft = total*(this.value/100);
        }
    }
}

export default FlowDiagram;
